import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/axiosInstance";
import endpoints from "../../../api/endpoints";
import axios from "axios";

export interface ReleveData {
  reference: string;
  echeance: string;
  exigible: number;
}

interface DownloadReleveState {
  data: ReleveData[];
  loading: boolean;
  error: string | null;
}

const initialState: DownloadReleveState = {
  data: [],
  loading: false,
  error: null,
};

export const downloadReleve = createAsyncThunk(
  "clients/downloadRelevé",
  async (numeroClient: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        endpoints.infosClient.downloadReleve + numeroClient
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data || "Network error");
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);

const downloadReleveSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadReleve.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadReleve.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.data = action.payload;
      })
      .addCase(downloadReleve.rejected, (state) => {
        state.loading = false;
        state.error = "Erreur lors du téléchargement du relevé";
      });
  },
});

export default downloadReleveSlice.reducer;
